import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const silicon: Partial<CaptionStyles> = {
  theme_preset: 'silicon',
  pageStyle: {
    color: '#ffffff'
  },
  wordStyle: {
    active: {
      color: '#ffffff'
    },
    inactive: {
      color: '#ffffff'
    },
    highlightType: HighlightTypeEnum.Box,
    highlightBoxStyle: {
      background: '#1348e6',
      borderRadius: '8px',
      inset: '-6px -12px'
    }
  },
  letterStyle: undefined,
  font_location: getFontFullPath('Poppins-Bold.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 64,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default silicon;
